'use strict';exports.__esModule = true;exports.receiveSimilarProjectProperties = exports.receiveProjectProperties = exports.clearPropertiesList = exports.changeActiveFiltersQuantity = exports.resetMobileMapState = exports.toggleMobileMap = exports.suppressLoading = exports.receiveProjectsCount = exports.receivePropertiesCount = exports.setPristenFilters = exports.resetFilters = exports.searchProperty = exports.loadMore = undefined;var _requestUrls;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var requestTypes = {
  homes: 'homes',
  commercial: 'commercial',
  projects: 'projects',
  projectsProperties: 'projectsProperties' };


var requestUrls = (_requestUrls = {}, _requestUrls[
requestTypes.homes] = '/properties/mixed_search', _requestUrls[
requestTypes.commercial] = '/properties/mixed_search', _requestUrls[
requestTypes.projects] = '/projects/search', _requestUrls[
requestTypes.projectsProperties] = '/projects/search', _requestUrls);


var loadPropertySuccess = (0, _reduxAct.createAction)('/LOAD_SUCCESS');
var loadPropertyFail = (0, _reduxAct.createAction)('/LOAD_FAIL');
var searchProperty = (0, _reduxAct.createAction)('/SEARCH_PROPERTY');
var loadMore = (0, _reduxAct.createAction)('/LOAD_MORE');
var resetFilters = (0, _reduxAct.createAction)('/RESET_FILTERS');
var setPristenFilters = (0, _reduxAct.createAction)('/SET_PRISTEN_FILTERS');
var receivePropertiesCount = (0, _reduxAct.createAction)('/RECEIVE_PROPERTIES_COUNT');
var receivePropertiesCountSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROPERTIES_COUNT_SUCCESS');
var receivePropertiesCountFail = (0, _reduxAct.createAction)('/RECEIVE_PROPERTIES_COUNT_FAIL');
var receiveProjectsCount = (0, _reduxAct.createAction)('/RECEIVE_PROJECTS_COUNT');
var receiveProjectsCountSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROJECTS_COUNT_SUCCESS');
var receiveProjectsCountFail = (0, _reduxAct.createAction)('/RECEIVE_PROJECTS_COUNT_FAIL');
var suppressLoading = (0, _reduxAct.createAction)('/SUPPRESS_PROPERTY_LOAD');
var toggleMobileMap = (0, _reduxAct.createAction)('/TOGGLE_MOBILE_MAP');
var resetMobileMapState = (0, _reduxAct.createAction)('/RESET_MOBILE_MAP_STATE');
var changeActiveFiltersQuantity = (0, _reduxAct.createAction)('/CHANGE_ACTIVE_FILTERS_QUANTITY');
var clearPropertiesList = (0, _reduxAct.createAction)('/CLEAR_PROPERTIES_LIST');
var receiveProjectProperties = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES');
var receiveProjectPropertiesSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES_SUCCESS');
var receiveProjectPropertiesFail = (0, _reduxAct.createAction)('/RECEIVE_PROJECT_PROPERTIES_FAIL');
var receiveSimilarProjectProperties = (0, _reduxAct.createAction)('/RECEIVE_SIMILAR_PROJECT_PROPERTIES');
var receiveSimilarProjectPropertiesSuccess = (0, _reduxAct.createAction)('/RECEIVE_SIMILAR_PROJECT_PROPERTIES_SUCCESS');
var receiveSimilarProjectPropertiesFail = (0, _reduxAct.createAction)('/RECEIVE_SIMILAR_PROJECT_PROPERTIES_FAIL');

var initialState = {
  loaded: false,
  loading: false,
  isResetedFilters: false,
  propertiesCount: null,
  projectsCount: null,
  suppressLoad: false,
  mobileMapIsVisible: null,
  activeFiltersQuantity: 0,
  projectPropertiesLoading: false,
  projectPropertiesData: [],
  similarProjectPropertiesData: [] };


var addCountryFilterIfNeeded = function addCountryFilterIfNeeded(params, type) {
  if (['homes', 'commercial'].includes(type)) {
    return Object.assign({},
    params, {
      country: 'Israel' });

  }
  return params;
};

var configureRequest = function configureRequest(_ref) {var params = _ref.params,type = _ref.type;
  var requestConfig = params.drawn ?
  { method: 'post', data: (0, _omit2.default)(params, ['is_mobile']) } :
  { method: 'get', params: addCountryFilterIfNeeded(params, type) };


  return Object.assign({
    url: requestUrls[type] },
  requestConfig);

};

var reduceData = function reduceData(_ref2) {var propertiesData = _ref2[0],projectsData = _ref2[1];return propertiesData.
  reduce(function (acc, item, idx) {
    acc.push(item);
    if ((idx + 1) % 5 === 0 && projectsData.length) {
      acc.push(projectsData.pop());
    }
    return acc;
  }, []);};

var sortResultsByDate = function sortResultsByDate(result) {return (
    result.sort(function (a, b) {
      a = Date.parse(a.updated_at || a.created_at);
      b = Date.parse(b.updated_at || b.created_at);
      return b - a;
    }));};

var fetchLoad = function fetchLoad(parameters) {var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'homes';
  var option = parameters.option === _constants.optionTypes.rent ?
  _constants.optionTypes.rent + ',' + _constants.optionTypes['rent-short'] :
  parameters.option;

  var data = Object.assign({}, parameters, { option: option });
  var defaultSort = parameters.street ? '-street_is_matched -search_date' : '-search_date';
  data.$sort = '' + (parameters.$sort || defaultSort);
  data.$limit = _constants.paginationParams.limit;
  data.$skip = skip;
  var requestConfig = configureRequest({ params: type === requestTypes.projects ? (0, _omit2.default)(data, ['street', 'is_mobile']) : data, type: type });

  return _axios2.default.request(requestConfig).
  then(loadPropertySuccess, loadPropertyFail);
};

var handleSearch = function handleSearch(state, _ref3) {var params = _ref3.params,_ref3$skip = _ref3.skip,skip = _ref3$skip === undefined ? 0 : _ref3$skip,type = _ref3.type;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    searching: true,
    params: params,
    isLastPage: false,
    skip: skip,
    sort: params.$sort,
    data: state.data,
    meta: Object.assign({}, state.meta) }),
  promise(fetchLoad, params, skip, type));};

var fetchProjectProperties = function fetchProjectProperties(parameters) {var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var data = Object.assign({}, parameters);
  data.$sort = '-search_date';
  data.$limit = _constants.paginationParams.limit;
  data.$skip = skip;

  var requestConfig = configureRequest({
    params: (0, _omit2.default)(data, ['street', 'is_mobile']),
    type: requestTypes.projectsProperties });


  return _axios2.default.request(requestConfig).
  then(receiveProjectPropertiesSuccess, receiveProjectPropertiesFail);
};

var handleProjectProperties = function handleProjectProperties(state, _ref4) {var params = _ref4.params,_ref4$skip = _ref4.skip,skip = _ref4$skip === undefined ? 0 : _ref4$skip,type = _ref4.type;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    projectPropertiesLoading: true }),
  promise(fetchProjectProperties, params, skip, type));};

var fetchSimilarProjectProperties = function fetchSimilarProjectProperties(parameters) {var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var data = Object.assign({}, parameters);
  data.$sort = '-search_date';
  data.$limit = _constants.paginationParams.limit;
  data.$skip = skip;

  var requestConfig = {
    params: (0, _omit2.default)(data, ['street', 'is_mobile']),
    method: 'get',
    url: '/projects/' + parameters.id + '/similar' };


  return _axios2.default.request(requestConfig).
  then(receiveSimilarProjectPropertiesSuccess, receiveSimilarProjectPropertiesFail);
};

var handleSimilarProjectProperties = function handleSimilarProjectProperties(state, _ref5) {var params = _ref5.params,_ref5$skip = _ref5.skip,skip = _ref5$skip === undefined ? 0 : _ref5$skip,type = _ref5.type;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    projectPropertiesLoading: true }),
  promise(fetchSimilarProjectProperties, params, skip, type));};

var handleProjectPropertiesSuccess = function handleProjectPropertiesSuccess(state, action) {return Object.assign({},
  state, {
    projectPropertiesLoading: false,
    projectPropertiesData: action.data.data });};


var handleProjectPropertiesFail = function handleProjectPropertiesFail(state, response) {return Object.assign({},
  state, {
    projectPropertiesLoading: false,
    projectPropertiesData: [],
    error: (0, _formatApiError2.default)(response, 'Error while getting properties') });};


var handleSimilarProjectPropertiesSuccess = function handleSimilarProjectPropertiesSuccess(state, action) {return Object.assign({},
  state, {
    projectPropertiesLoading: false,
    similarProjectPropertiesData: action.data });};


var handleSimilarProjectPropertiesFail = function handleSimilarProjectPropertiesFail(state, response) {return Object.assign({},
  state, {
    projectPropertiesLoading: false,
    similarProjectPropertiesData: [],
    error: (0, _formatApiError2.default)(response, 'Error while getting properties') });};


var handleLoadMore = function handleLoadMore(state, _ref6) {var type = _ref6.type,is_mobile = _ref6.is_mobile;
  var params = Object.assign({}, state.params, { counters: undefined, is_mobile: is_mobile });

  return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    params: type === 'projects' ? (0, _omit2.default)(params, ['street']) : params,
    skip: state.skip + _constants.paginationParams.skip }),
  promise(fetchLoad, params, state.skip + _constants.paginationParams.skip, type));
};

var handleLoadSuccess = function handleLoadSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    isLastPage: !action.data.meta.hasNextPage,
    data: state.skip === 0 ? action.data.data : [].concat(state.data, action.data.data),
    meta: action.data.meta });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while searching properties');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    meta: null,
    isLastPage: false,
    error: error });

};

var handleReset = function handleReset(state) {return Object.assign({},
  state, {
    isResetedFilters: true });};


var handleSetPristin = function handleSetPristin(state) {return Object.assign({},
  state, {
    isResetedFilters: false });};


var fetchLoadCount = function fetchLoadCount(parameters) {
  var option = parameters.params.option === _constants.optionTypes.rent ?
  _constants.optionTypes.rent + ',' + _constants.optionTypes['rent-short'] :
  parameters.params.option;

  parameters.params.option = option;var
  params = parameters.params,type = parameters.type;
  var requestConfig = configureRequest({ params: type === 'projects' ? (0, _omit2.default)(params, ['street', 'is_mobile']) : params, type: type });
  requestConfig.url = requestConfig.url.replace(/search/g, 'count');

  return _axios2.default.request(requestConfig).
  then(receivePropertiesCountSuccess, receivePropertiesCountFail);
};

var fetchLoadProjectsCount = function fetchLoadProjectsCount(_ref7) {var params = _ref7.params,type = _ref7.type;
  var requestConfig = configureRequest({
    params: Object.assign({},
    (0, _pick2.default)(params, [params.drawn ? 'drawn' : 'loc', 'city']), {
      property_types: params.type,
      min_property_price: params.min,
      max_property_price: params.max }),

    type: 'projects' });

  requestConfig.url = requestConfig.url.replace(/search/g, 'count');

  var request = _axios2.default.request(requestConfig);

  if (type !== 'homes' || params.option !== 'buy') {
    request = Promise.resolve({ data: 0 });
  }

  return request.
  then(receiveProjectsCountSuccess, receiveProjectsCountFail);
};

var handleReceivePropertiesCount = function handleReceivePropertiesCount(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loadingCount: true,
    loadedCount: false }),
  promise(fetchLoadCount, data));};

var handleReceiveProjectsCount = function handleReceiveProjectsCount(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state),
  promise(fetchLoadProjectsCount, data));};

var handleReceivePropertiesCountSuccess = function handleReceivePropertiesCountSuccess(state, _ref8) {var data = _ref8.data;return Object.assign({},
  state, {
    loadingCount: false,
    loadedCount: true,
    propertiesCount: data });};


var handleReceivePropertiesCountFail = function handleReceivePropertiesCountFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed receive property count');

  return Object.assign({},
  state, {
    loadingCount: false,
    loadedCount: false,
    propertiesCount: 0,
    error: error });

};

var handleReceiveProjectsCountSuccess = function handleReceiveProjectsCountSuccess(state, _ref9) {var data = _ref9.data;return Object.assign({},
  state, {
    loadingCount: false,
    loadedCount: true,
    projectsCount: data });};


var handleReceiveProjectsCountFail = function handleReceiveProjectsCountFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed receive property count');

  return Object.assign({},
  state, {
    loadingCount: false,
    loadedCount: false,
    projectsCount: 0,
    error: error });

};

var handleSuppressPropertyLoading = function handleSuppressPropertyLoading(state, suppressLoad) {return Object.assign({},
  state, {
    suppressLoad: suppressLoad });};


var handleToggleMobileMap = function handleToggleMobileMap(state, mobileMapIsVisible) {
  var mapIsVisible = mobileMapIsVisible === true || mobileMapIsVisible === false || mobileMapIsVisible === null ?
  mobileMapIsVisible :
  !state.mobileMapIsVisible;

  return Object.assign({},
  state, {
    mobileMapIsVisible: mapIsVisible });

};

var handleResetMobileMapState = function handleResetMobileMapState(state) {
  var mobileMapIsVisible = state.suppressLoad ? state.mobileMapIsVisible : false;

  return Object.assign({},
  state, {
    mobileMapIsVisible: mobileMapIsVisible });

};

var handleChangeActiveFiltersQuantity = function handleChangeActiveFiltersQuantity(state, quantity) {return Object.assign({},
  state, {
    activeFiltersQuantity: quantity });};


var handleClearPropertiesList = function handleClearPropertiesList(state) {return Object.assign({},
  state, {
    projectPropertiesLoading: false,
    projectPropertiesData: null,
    similarProjectPropertiesData: null,
    data: null,
    propertiesCount: null,
    loading: false,
    loaded: false,
    suppressLoad: false });};


var propertySearch = (0, _reduxAct.createReducer)(function (on) {
  on(loadPropertySuccess, handleLoadSuccess);
  on(loadPropertyFail, handleLoadFail);
  on(searchProperty, handleSearch);
  on(loadMore, handleLoadMore);
  on(resetFilters, handleReset);
  on(setPristenFilters, handleSetPristin);
  on(receivePropertiesCount, handleReceivePropertiesCount);
  on(receivePropertiesCountSuccess, handleReceivePropertiesCountSuccess);
  on(receivePropertiesCountFail, handleReceivePropertiesCountFail);
  on(receiveProjectsCount, handleReceiveProjectsCount);
  on(receiveProjectsCountSuccess, handleReceiveProjectsCountSuccess);
  on(receiveProjectsCountFail, handleReceiveProjectsCountFail);
  on(suppressLoading, handleSuppressPropertyLoading);
  on(toggleMobileMap, handleToggleMobileMap);
  on(resetMobileMapState, handleResetMobileMapState);
  on(changeActiveFiltersQuantity, handleChangeActiveFiltersQuantity);
  on(clearPropertiesList, handleClearPropertiesList);
  on(receiveProjectPropertiesSuccess, handleProjectPropertiesSuccess);
  on(receiveProjectPropertiesFail, handleProjectPropertiesFail);
  on(receiveProjectProperties, handleProjectProperties);
  on(receiveSimilarProjectPropertiesSuccess, handleSimilarProjectPropertiesSuccess);
  on(receiveSimilarProjectPropertiesFail, handleSimilarProjectPropertiesFail);
  on(receiveSimilarProjectProperties, handleSimilarProjectProperties);
}, initialState);exports.


loadMore = loadMore;exports.
searchProperty = searchProperty;exports.
resetFilters = resetFilters;exports.
setPristenFilters = setPristenFilters;exports.
receivePropertiesCount = receivePropertiesCount;exports.
receiveProjectsCount = receiveProjectsCount;exports.
suppressLoading = suppressLoading;exports.
toggleMobileMap = toggleMobileMap;exports.
resetMobileMapState = resetMobileMapState;exports.
changeActiveFiltersQuantity = changeActiveFiltersQuantity;exports.
clearPropertiesList = clearPropertiesList;exports.
receiveProjectProperties = receiveProjectProperties;exports.
receiveSimilarProjectProperties = receiveSimilarProjectProperties;exports.default =


propertySearch;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertySearch.js
// module id = 170
// module chunks = 0